module.exports = __webpack_public_path__ + "static/media/start-rotate-1.272be4aa.png";